export default {
  isMixin() {
    return Boolean(this.getMixinContext().platform);
  },

  getLocale() {
    let locale = navigator.language;
    if (this.isMixin()) {
      const context = this.getMixinContext();
      if (context && context.language) {
        locale = context.language;
      }
    }
    return locale.includes("ja") ? "ja" : locale.includes("zh") ? "zh" : "en";
  },

  getMixinContext() {
    let ctx: any = {};
    const win: any = window;
    if (
      win.webkit &&
      win.webkit.messageHandlers &&
      win.webkit.messageHandlers.MixinContext
    ) {
      ctx = JSON.parse(prompt("MixinContext.getContext()") as any);
      ctx.platform = ctx.platform || "iOS";
    } else if (
      win.MixinContext &&
      typeof win.MixinContext.getContext === "function"
    ) {
      ctx = JSON.parse(win.MixinContext.getContext());
      ctx.platform = ctx.platform || "Android";
    }
    return ctx;
  }
};
